import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import api from "api";
import { debug } from "utils";

import { FiMoreHorizontal, FiInfo } from "react-icons/fi";
import { Tooltip } from "bootstrap";
import './formalities-status-card.css';
const FormalitiesStatusCards = () => {
  const config = useSelector((state) => state.config);
  const statuses = config?.formalities?.requests?.status || {};
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach(
      (el) => new Tooltip(el)
    );
  }, []);
  useEffect(() => {
    api
      .get("/admin/formalities/requests/metrics")
      .then((res) => {
        setMetrics(res.data.by_status || {});
      })
      .finally(() => setLoading(false));
  }, []);
  return (
    <div className="formalities-status-card">
      <div className="row g-3">
        {Object.entries(statuses)
          .filter(([key, status]) => key !== "all" && status.active !== false)
          .sort(([, a], [, b]) => (a.level ?? 0) - (b.level ?? 0))
          .map(([key, status]) => (
            <div className="col-12 col-sm-6 col-md-3 col-xl-2" key={key}>
              <Link
                to={`/admin/formalities/requests/list?status=${key}`}
                className="card h-100 shadow-sm text-decoration-none text-reset"
              >
                {/* Header */}
                <div
                  className="card-header d-flex align-items-center justify-content-between text-white fw-semibold"
                  style={{ backgroundColor: status.color }}
                >
                  <span>{status.label}</span>

                  {status.description && (
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title={status.description}
                      style={{ cursor: "help" }}
                      onClick={(e) => e.stopPropagation()} // important
                    >
                      <FiInfo size={16} />
                    </span>
                  )}
                </div>

                {/* Body */}
                <div className="card-body text-center">
                  <div className="fs-3 fw-bold">
                    {loading ? "—" : metrics?.[key] ?? "_"}
                  </div>
                </div>
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FormalitiesStatusCards;
